export default class Formatter {
    constructor() { }

    public parseUtcDate(value) {
        if (!value) return null;
        if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
        if (typeof value === 'number') {
            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? null : date;
        }

        const text = String(value).trim();
        if (!text) return null;

        let normalized = text;
        const hasTimeZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(normalized);
        if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
            normalized = `${normalized}T00:00:00Z`;
        } else if (!hasTimeZone && /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(normalized)) {
            normalized = normalized.replace(' ', 'T') + 'Z';
        }

        const date = new Date(normalized);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    public kstDateTime(value, text = "-") {
        const date = this.parseUtcDate(value);
        if (!date) return text;

        const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).formatToParts(date).reduce((acc: any, part: any) => {
            acc[part.type] = part.value;
            return acc;
        }, {});
        const hour = parts.hour === '24' ? '00' : parts.hour;
        return `${parts.year}-${parts.month}-${parts.day} ${hour}:${parts.minute}`;
    }

    public kstDate(value, text = "-") {
        const date = this.parseUtcDate(value);
        if (!date) return text;

        const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(date).reduce((acc: any, part: any) => {
            acc[part.type] = part.value;
            return acc;
        }, {});
        return `${parts.year}-${parts.month}-${parts.day}`;
    }

    public date(date, text) {
        if (!text) text = "-";
        return this.kstDate(date, text);
    }

    public currency(number, isString = true) {
        if (!number) return "-";
        if (isString) {
            let num = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num + "원";
        }

        const units = ['', '만', '억', '조', '경'];
        const parts = [];
        let remaining = number;

        for (let i = units.length - 1; i >= 0; i--) {
            const unit = Math.pow(10000, i);
            const part = Math.floor(remaining / unit);
            remaining = remaining % unit;

            if (part > 0) {
                parts.push(part + units[i]);
            }
        }

        if (remaining > 0) {
            parts.push(remaining);
        }
        if (parts.length == 0) return '-';
        return parts.join(' ') + '원';
    }

}
